import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "ユーザ設定", -1)
const _hoisted_2 = { class: "mt20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "WEB PUSH設定", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "WEB通知をONにするために設定ボタンを押して下さい", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("設定")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "WEB PUSH通知はONですが、届かない場合は再設定ボタンを押して下さい", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("再設定")

import { ref, onMounted } from 'vue'
import webpush from '@/utils/ServiceWorkerRegister.js'
import { ElMessage } from "element-plus"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const webpush_stats = ref("")
onMounted(() => {
  webpush_stats.value = webpush.webPushStatus();
})
const webpushOn = () => {
  Notification.requestPermission(state => {
    if (state === "granted") {
      webpush.setPushServiceUser().then(
        response => {
          webpush_stats.value = webpush.webPushStatus();
          ElMessage({
            showClose: true,
            message: "再設定しました",
            type: 'success'
          });
        },
        error => { }
      );
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, { class: "container__card" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_card, { shadow: "never" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _withDirectives(_createElementVNode("div", null, " WEB PUSHの通知が無効になっています。通知を受け取る場合はブラウザの設定から通知を許可してください (chromeの場合はURLの左のアイコンより許可することができます) ", 512), [
                  [_vShow, webpush_stats.value == 'denied']
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _hoisted_4,
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: webpushOn
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, webpush_stats.value == 'default']
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _hoisted_6,
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: webpushOn
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, webpush_stats.value == 'granted']
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})